<template>
  <div>
    <h1 class="page-header">{{ $t('payrollCycle.pageTitle') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-10">
            <ts-button color="info" outline @click="showForm()">
              {{ $t('addNew') }}
            </ts-button>
          </div>
          <div class="col-sm-12 col-md-2 d-flex justify-content-end">
            <ts-input v-model="search" :placeholder="$t('search')" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record, index }">
          <td>{{ record.cycle_year }}</td>
          <td>{{ getMonth(record.cycle_month) }}</td>
          <td>{{ record.cycle_status }}</td>
          <td class="text-center">
            <span class="badge badge-success" v-if="record.is_released">Yes</span>
            <span class="badge badge-danger" v-else>No</span>
          </td>
          <td>{{ record.released_date }}</td>
          <td>{{ record.realease_by_user ? record.realease_by_user.full_name : '' }}</td>
          <td class="text-center">
            <span class="badge badge-success" v-if="record.is_notification_sent">Yes</span>
            <span class="badge badge-danger" v-else>No</span>
          </td>
          <td>{{ record.date_sent }}</td>
          <td class="text-center">
            <a href="#" v-tooltip="'Edit'" class="text-primary mr-2" @click.prevent="edit(record)">
              <i class="fas fa-edit"></i>
            </a>
            <a
              href="#"
              v-tooltip="'Release'"
              class="text-warning"
              @click.prevent="destroy(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="far fa-registered" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState, mapGetters } from 'vuex'
import FormComponent from './form.vue'

export default {
  name: 'payroll-cycle',
  components: {
    FormComponent
  },
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('hr/payrollCycle', ['resources', 'pagination']),
    ...mapGetters('hr/payrollCycle', ['getMonth']),
    search: {
      get() {
        return this.$store.state.hr.payrollCycle.search
      },
      set(newValue) {
        this.$store.commit('hr/payrollCycle/SET_SEARCH', newValue)
        this.$store.commit('hr/payrollCycle/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('payrollCycle.cycleYear')
        },
        {
          name: this.$t('payrollCycle.cycleMonth')
        },
        {
          name: this.$t('payrollCycle.cycleStatus')
        },
        {
          name: this.$t('payrollCycle.isReleased'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('payrollCycle.releasedDate')
        },
        {
          name: this.$t('payrollCycle.releasedBy')
        },
        {
          name: this.$t('payrollCycle.isNotificationSent'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('payrollCycle.dateSent')
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 7%;' }
      ]
    }
  },
  methods: {
    fetchData() {
      this.loading = true
      this.$store
        .dispatch('hr/payrollCycle/fetch')
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    showForm(editData) {
      this.$modal.show(
        FormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '400px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    edit(record) {
      this.showForm(record)
    },
    async destroy(record) {
      if (await this.$confirmModal.danger(this.$t('payrollCycle.are_you_sure_to_release'))) {
        record._deleting = true
        this.$store
          .dispatch('hr/payrollCycle/release', record.payroll_cycle_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/payrollCycle/RESET_STATE')
    next()
  }
}
</script>
